module.exports = __webpack_public_path__ + "static/media/tooltip-point.d26c27f3.svg";